import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';
import { maskAddressValue } from '@/utils/format';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function HyperliquidTradeTriggerFullDetails({ trigger }: Props) {
  const builderDisplay = useMemo(() => {
    const builderAddress = trigger.context?.builderAddress;

    if (!builderAddress) return '-';

    const builderNames: Record<string, string> = {
      '0x8af3545a3988b7A46f96F9F1AE40c0e64Fa493C2': 'HyperSignals',
    };

    const builderName = builderNames[builderAddress] || maskAddressValue(builderAddress);

    return <Badge size="sm">{builderName}</Badge>;
  }, [trigger.context?.builderAddress]);

  const executedWhenDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          User trades on
        </Text>
        <Badge size="sm">Hyperliquid</Badge>
        <Text as="span" variant="body-sm" color="muted">
          platform via the selected builder
        </Text>
      </div>
    );
  }, []);

  const contextDisplay = useMemo(() => {
    const context = trigger.context;
    if (!context) return '-';

    return (
      <div className="tw:flex tw:flex-col tw:gap-2">
        <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
          <Text as="span" variant="body-sm" color="muted">
            Builder Address:
          </Text>
          <Text as="span" variant="body-sm">
            {context.builderAddress || '-'}
          </Text>
        </div>
      </div>
    );
  }, [trigger.context]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Builder" value={builderDisplay} />
      <KeyValueRow label="Volume Expression" value={trigger.volumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Expression" value={trigger.revenueExpression ?? '-'} />
      <KeyValueRow label="Volume Currency" value={trigger.currencyVolumeExpression ?? '-'} />
      <KeyValueRow label="Revenue Currency" value={trigger.currencyRevenueExpression ?? '-'} />
      <KeyValueRow label="Context" value={contextDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
